<template>
    <div class="content_box nopadding mobile_content">
        <div class="top fixed_top el_form">
            <div class="title">
                <span>设备地域分布</span> &nbsp;&nbsp;
                <el-select v-model="productKey" clearable size="medium" placeholder="产品">
                    <el-option :label="item.name" :value="item.productKey" v-for="item in productTypes" :key="item.productKey + '22123'"></el-option>
                </el-select>
            </div>
        </div>
        <div class="area">
            <div class="content device-operation">
                <div class="distribution">
                    <div class="data_box">
                        <div class="data_item" :class="{data_select: select_item == 'create_all'}" @click="select_item = 'create_all'">
                            <p class="label">累计激活设备</p>
                            <p class="number">{{formatNumber(deviceData.create_sum || 0)}}</p>
                        </div>
                        <div class="data_item data_item_center" :class="{data_select: select_item == 'create30_list'}" @click="select_item = 'create30_list'">
                            <p class="label">近30天新增激活设备</p>
                            <p class="number">{{formatNumber(deviceData.create30_sum || 0)}}</p>
                        </div>
                        <div class="data_item" :class="{data_select: select_item == 'active30_list'}" @click="select_item = 'active30_list'">
                            <p class="label">近30天活跃设备</p>
                            <p class="number">{{formatNumber(deviceData.active30_sum || 0)}}</p>
                        </div>
                    </div>
                    <div class="echarts_box" >
                        <div class="world_chart chart" ref="world_chart"></div>
                    </div>
                </div>
                <div class="trend">
                    <div class="padding trend_table">
                        <div class="title subtitle title-1">
                            <span>数据明细</span>
                        </div>
                        <div class="line"></div>
                        <el-table
                            highlight-current-row
                            :data="trendTableData">
                            <el-table-column type="index" :index="(page - 1) * page_size + 1" width="70"></el-table-column>
                            <el-table-column prop="country" label="国家/地区" align="left">
                                <template slot-scope="scope">
                                    <span>{{scope.row.country || '其他'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="累计激活设备数" v-if="select_item == 'create_all'">
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.count)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="近30天新增激活设备" v-if="select_item == 'create30_list'">
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.count)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="近30天活跃设备" v-if="select_item == 'active30_list'">
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.count)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="占比" >
                                <template slot-scope="scope">
                                    <span>{{scope.row.rate + '%'}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <Pagination :total="trendeData.length" :page="page" @paginationChange="initTableData"></Pagination>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>    
<script>
import '../../../../static/echarts/maps'
import '../../../../static/echarts/world'
import nameMap from '../../../js/nameMap'
export default({
    name: 'device-geo',
    data() {
        return {
            resizeTimer: null,
            select_item: 'create_all',
            productTypes: [],
            productKey: '',
            deviceData: {},
            trendeData: [],
            trendTableData: [],
            page_size: 10,
            page: 1
        }
    },
    watch: {
        productKey(nK) {
            this.getDeviceGeo();
        },
        select_item(nS) {
            this.initWorld();
        }
    },
    created() {
        this.getProductList();
        this.getDeviceGeo();
    },
    activated() {
        window.addEventListener('resize', this.onresize);
    },
    deactivated() {
		// 取消监听事件
		window.removeEventListener('resize', this.onresize);
	},
    methods: {
        onresize() {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() => {
				var worldChart = this.echarts.getInstanceByDom(this.$refs.world_chart);
                worldChart.resize();
			}, 200);
		},
        getProductList() {
            this.api.getIotProductList({}).then(data => {
                this.productTypes = [{name: '全部产品', productKey: ''} ,...data.data.result];
            })
        },
        getDeviceGeo() {
            this.api.getDeviceGeo({product_key: this.productKey}).then(data => {
                this.deviceData = data.data;
                this.initWorld();
            })
        },
        initTableData(data) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendeData.length; i++) {
                this.trendTableData.push(this.trendeData[i]);
                if(this.trendTableData.length == data.page_size) break;
            }
        },
        initWorld() {
			let world_chart_data = [], vArr = [], label = '近30天活跃设备';
			this.trendeData = this.deviceData[this.select_item];
            this.initTableData({page_size: this.page_size, page: 1});
            if(this.select_item == 'create_all') {
                label = '累计激活设备';
            }else if(this.select_item == 'create30_list'){
                label = '近30天新增激活设备';
            }
            this.trendeData.forEach(item => {
                if(item.country) {
                    world_chart_data.push({name: item.country, value: item.count, other: `<span style="color:#868998;">${label}:&nbsp;</span>${item.count}&nbsp;&nbsp;&nbsp;${item.rate}%`});
                }
                vArr.push(item.count || 0);
            })
			let worldChart = this.echarts.getInstanceByDom(this.$refs.world_chart);
            if(worldChart == null) {
                worldChart = this.echarts.init(this.$refs.world_chart);
            }
            if(vArr.length == 0) {
                worldChart.setOption(this.setMapOption(world_chart_data, 0, 1));
            }else if(vArr.length == 1){
                worldChart.setOption(this.setMapOption(world_chart_data, 0, Math.max(...vArr)));
            }else{
                worldChart.setOption(this.setMapOption(world_chart_data, Math.min(...vArr), Math.max(...vArr)));
            }
        	
		},
        setMapOption(value, min, max) {
            return {
				tooltip: {
					trigger: 'item',
					borderColor: '#fff',
                    textStyle: {
                        color: '#2B2B35',
                    },
					formatter: (p) => {
						return `<span style="color:#507FF7;font-weight: 600;line-height:30px;">${p.name}</span><br />${p.data ? p.data.other : '--'}`;
					}
				},
                visualMap: [{  // 映射-颜色值
					min: min,
                    max: max,
                    text: ['高', '低'],
                    inRange: {
                        color: ['#E3EAFE', '#648DF7']
                    }
				}],
				series: [{
					name: "世界地图",
					type: "map",  // 配置图表类型
					map: "world", // 地图
					roam: false,  // 是否允许自动缩放
					zoom: 1.15,    // 地图缩放比例
					label: {      // 配置字体
						show: false,  // 控制地图显示名字
						fontSize: 8,
					},
					itemStyle: {  // 配置地图样式
						color: '#fff',
						areaColor: '#F6F9FF',
						borderColor: '#fff',
					},
					emphasis: {// 选中的区域颜色及阴影效果等
						label: {
							color: '#000',
						},
						itemStyle: {
							areaColor: '#648DF7',
							shadowOffsetX: 0,
							shadowOffsetY: 0,
							shadowBlur: 20,
							borderWidth: 0,
						}
					},
					select: {
						disabled: true,
						label: {
							color: '#000',
						},
						itemStyle: {
							areaColor: 'none',
						}
					},
					data:value,
					nameMap: nameMap,  //world.js   name  中英文映射关系
				}]
            };
        },
    }
})
</script>
<style lang="less" scoped>
    @import '../../../less/statistics.less';
    .distribution{
        .data_box{
            .flexLayout(space-between);
            flex-wrap: nowrap;
            .data_item{
                padding: 20px;
                flex: 1;
                box-sizing: border-box;
                text-align: center;
                border: 1px solid #E8E9F1;
                border-radius: 24px;
                line-height: 2;
                margin-bottom: 10px;
                cursor: pointer;
                .number{
                    font-size: 20px;
                    font-weight: 600;
                }
                &.data_item_center{
                    margin: 0 20px 10px;
                }
                &.data_select{
                    color: @colorBlue2;
                    border: 2px solid @colorBlue2;
                }
            }
            @media (max-width: 550px) {
                flex-wrap: wrap;
                .data_item{
                    min-width: 100%;
                    &.data_item_center{
                    margin: 0 0 20px;
                }
                }
            }
        }
        .world_chart{
            width: 100%;
            height: 620px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/statistics/device/device-geo.vue